import { defineMessages } from "react-intl";

const messages = defineMessages({
  create: {
    id: "view.selectBar.addRemove.routes.createButton",
    defaultMessage: "+ Create new route",
    description: "Create new route button label",
  },
  groupsPlaceholder: {
    id: "view.selectBar.addRemove.routes.placeholder",
    defaultMessage: "Select",
    description: "Placeholder displayed in a route select field",
  },
  information: {
    id: "view.selectBar.addRemove.routes.information",
    defaultMessage:
      "Routes can only be constructed with either companies or people. Deals may be included on a route only if they have an association with that record type.",
    description: "Panel information",
  },
  selectGroup: {
    id: "view.selectBar.addRemove.routes.selectGroup.label",
    defaultMessage: "Select route(s)",
    description: "Route selector label",
  },
  selectOne: {
    id: "view.selectBar.addRemove.routes.selectOne.label",
    defaultMessage: "Select one",
    description: "Operation selector label",
  },
  title: {
    id: "view.selectBar.addRemove.routes.title",
    defaultMessage: "Add to / remove from routes",
    description: "Panel title",
  },
});

export default messages;
